import cn from 'classnames';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { SHARE_CTA_ACTION_LINK } from 'constants/events';
import { HELP_SHARE_VIDEO } from 'constants/feature-tour';
import * as analytics from 'utilities/analytics';
import * as clipboard from 'utilities/clipboard';

import ActionDot, { TOP_LEFT } from 'components/ui-components/action-dot';
import Button from 'components/ui-components/button';

import styles from './styles.module.less';

class CopyLinkSection extends PureComponent {
  static defaultProps = {
    video: {},
    withLinkActionDot: false,
    className: '',
  };

  state = {
    resultText: null,
  };

  trackEvent(type) {
    analytics.track(type, { video_id: this.props.video.id });
  }

  copy = () => {
    if (this.copyTimeout) {
      window.clearTimeout(this.copyTimeout);
      this.copyTimeout = null;
    }

    const didCopy = clipboard.copy(this.inputElement);

    let resultText;

    if (didCopy) {
      resultText = 'Link Copied!';
    } else {
      resultText = 'Error! :-(';
    }

    this.setState({
      resultText,
    });

    this.copyTimeout = window.setTimeout(() => {
      this.setState({
        resultText: null,
      });

      this.copyTimeout = null;

      // stay opaque for a time before fading back out
    }, 2000);

    this.trackEvent(SHARE_CTA_ACTION_LINK);
  };

  render() {
    const { shareVideoTourIsActive } = this.props;

    const { resultText } = this.state;

    return (
      <div
        className={cn(
          styles.linkAndButtons,
          resultText ? styles.copyLinkActivated : '',
          'mt:medium'
        )}
      >
        <span
          className={cn(styles.linkBox, 'mb:xsmall', 'bgc:white')}
          onClick={() => this.copy()}
        >
          <input
            className={cn(styles.input, 'text:medium', 'c:grey8')}
            ref={me => (this.inputElement = me)}
            readOnly
            value={window.location.href}
          />
        </span>
        <div className={styles.copyButtonWrapper}>
          {shareVideoTourIsActive && <ActionDot position={TOP_LEFT} />}
          <Button
            onClicked={this.copy}
            buttonClass={cn('rp-primary-3', styles.copyButton, styles.copyLink)}
            value={resultText || 'Copy Link'}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { currentTour, tourOpenAndActive } = state.featureTour;

  const shareVideoTourIsActive =
    currentTour === HELP_SHARE_VIDEO && tourOpenAndActive;

  return {
    shareVideoTourIsActive,
  };
};

export default connect(mapStateToProps)(CopyLinkSection);
